import React, { Component } from 'react'
import { NotificationTheme } from 'modules/theme'

export class Notification extends Component {
  render() {
    return (
      <div><NotificationTheme /></div>
    )
  }
}

export default Notification


// WEBPACK FOOTER //
// src/dialpad/components/layout/Notification.js